var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import React, { useState } from "react";
import { Collapse, Button } from "reactstrap";

import Icon from "../Icon";
import "./DropdownIcon.css";

var DropdownIcon = function DropdownIcon(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      collapse = _useState2[0],
      setCollapse = _useState2[1];

  var _useState3 = useState("poli-icon pi-simple-arrow-down-line-animation"),
      _useState4 = _slicedToArray(_useState3, 2),
      status = _useState4[0],
      setStatus = _useState4[1];

  var onEntered = function onEntered() {
    return setStatus("poli-icon pi-simple-arrow-right-line-animation");
  };
  var onExited = function onExited() {
    return setStatus("poli-icon pi-simple-arrow-down-line-animation");
  };

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      active = _useState6[0],
      setActive = _useState6[1];

  return React.createElement(
    "div",
    { className: "DropdownIcon" },
    React.createElement(
      Button,
      {
        color: "reply-collapse",
        active: active,
        style: styles.buttonContainerIcon,
        onClick: function onClick() {
          setCollapse(!collapse);
          if (active) {
            setActive(false);
          } else if (!active) {
            setActive(true);
            if (props.doSomething) {
              props.doSomething();
            }
          }
        }
      },
      React.createElement(Icon, { style: styles.iconMain, size: 22, icon: props.principalIcon }),
      props.principalTitle,
      " ",
      React.createElement(Icon, { size: 16, icon: status })
    ),
    React.createElement(
      Collapse,
      {
        className: "dropicons",
        isOpen: collapse,
        onEntered: onEntered,
        onExited: onExited
      },
      props.children
    )
  );
};

var styles = {
  buttonContainerIcon: {
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "0.5rem",
    textAlign: "left",
    position: "relative",
    top: "-17px",
    left: "-6px"
  },
  buttonItens: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem"
  },
  iconMain: {
    position: "relative",
    top: "5px"
  }
};

export default DropdownIcon;